import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { ConfirmProvider } from '@nepal-ecom/ui';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 2, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'rounded-xl border border-slate-100 shadow-pop',
          style: { fontFamily: 'Inter, system-ui, sans-serif' },
        }}
        richColors
        closeButton
      />
    </QueryClientProvider>
  </React.StrictMode>
);
